import { defineStore } from 'pinia';
import apiClient from '../config/api.js';
//import { useFhirStore } from './fhir';
import { useMuster15ResourcesStore } from './fhirResources/muster15Resources';
import { useMuster16ResourcesStore } from './fhirResources/muster16Resources';
import { useMuster12ResourcesStore } from './fhirResources/muster12Resources';
export const useDbStore = defineStore('db', {
  state: () => ({
    practitioners: [],
    patients: [],
    organizations: [],
    medications: [],
    selectedPractitioner: null,
    selectedPatient: null,
    selectedOrganization: null,
    selectedMedicationPZN: null,
    medicationFreitext: null,
    medicationDarreichungsform: null,
    dataFetched: false,
    currentBundle: null,
    createTaskResponse: null,
    idpToken: null,
    deviceData: null,
    muster15Data: null,
    showMusterModal: false,
    selectedFormType: null,
  }),

  actions: {

    async getIdpToken() {
      try {
        const response = await apiClient.get('/getIdpToken', {
          params: { healthcards: 'SMCB_KRANKENHAUS' }
        });
        this.idpToken = response.data.accessToken;
        return this.idpToken;
      } catch (error) {
        console.error('Error fetching IDP token:', error);
        throw error;
      }
    },

    async createTask() {
      await this.getIdpToken();
      try {
        const response = await apiClient.post('/createTask?idpToken=' + this.idpToken);
        this.createTaskResponse = response.data;
        return;
      } catch (error) {
        console.error('Error fetching create task response:', error);
        throw error;
      }
    },

    async signDocumentWithTool(xmlBundle) {
      try {
        const response = await apiClient.post('/signDocumentWithTool', xmlBundle, {
          headers: { 'Content-Type': 'text/plain' }
        });
        return response.data;
      } catch (error) {
        console.error('Error signing document:', error);
        throw error;
      }
    },

    async activateTask(taskId, accessCode, qesBundle) {
      try {
        const response = await apiClient.post('/activateTask', 
          { taskId, accessCode, qesBundle },
          { params: { idpToken: this.idpToken } }
        );
        return response.data;
      } catch (error) {
        console.error('Error activating task:', error);
        throw error;
      }
    },

    async convertFhirJSONtoXML(fhirJSON) {
      const jsonString = JSON.stringify(fhirJSON);
      console.log('Ausgehender Request für convertFhirJSONtoXML:', jsonString);
      const response = await apiClient.post('/convertFhirJSONtoXML', jsonString, {
        headers: { 'Content-Type': 'text/plain' }
      });
      return response.data;
    },

    async einstellenERezept() {
      if (!this.currentBundle) {
        throw new Error('Kein E-Rezept Bundle vorhanden');
      }

      const xmlBundle = await this.convertFhirJSONtoXML(this.currentBundle.bundle);
      //const createTaskResponse = this.currentBundle.createTaskResponse;

      try {
        const signedBundle = await this.signDocumentWithTool(xmlBundle);
        await this.getIdpToken();
        await this.activateTask(
          this.createTaskResponse.prescriptionId,
          this.createTaskResponse.accessCode,
          signedBundle
        );
      } catch (error) {
        console.error('Fehler beim Einstellen des E-Rezepts:', error);
        throw error;
      }
    },

    setSelectedMedicationPZN(pzn) {
      this.selectedMedicationPZN = pzn;
      // Wenn eine PZN gesetzt wird, löschen wir die Freitext-Daten
      this.medicationFreitext = null;
      this.medicationDarreichungsform = null;
      this.deviceData = null;
      this.muster15Data = null;
    },

    setMedicationFreitext(medikament, darreichungsform) {
      this.medicationFreitext = medikament;
      this.medicationDarreichungsform = darreichungsform;
      // Wenn Freitext gesetzt wird, löschen wir die PZN
      this.selectedMedicationPZN = null;
      this.muster15Data = null;
    },

    setDeviceData(data) {
      this.deviceData = data;
      this.muster15Data = null;
      this.selectedMedicationPZN = null;
      this.medicationFreitext = null;
      this.medicationDarreichungsform = null;
    },

    setMuster15Data(data) {
      this.muster15Data = data;
      this.selectedMedicationPZN = null;
      this.medicationFreitext = null;
      this.medicationDarreichungsform = null;
      this.deviceData = null;
    },

    async createMuster12Bundle() {
      const muster12Resources = useMuster12ResourcesStore();
      await this.createTask();
      const bundle = muster12Resources.createMuster12Bundle();
      this.currentBundle = { bundle };
      return this.currentBundle;
    },

    async createERezeptBundle(prescriptionType) {
      try {
        if (!this.idpToken) {
          await this.getIdpToken();
        }

        //const fhirStore = useFhirStore();
        const muster15Resources = useMuster15ResourcesStore();
        const muster16Resources = useMuster16ResourcesStore();

        if (prescriptionType === 'PZN-Verordnung' || prescriptionType === 'Freitextverordnung') {
          await this.createTask();
          const bundle = prescriptionType === 'PZN-Verordnung' 
            ? muster16Resources.createMuster16Bundle()
            : muster16Resources.createMuster16FreitextBundle();
          this.currentBundle = { bundle };
          return this.currentBundle;
        } else if (prescriptionType === 'Hilfsmittelverordnung') {
          await this.createTask();
          const bundle = muster16Resources.createMuster16HilfsmittelBundle();
          this.currentBundle = { bundle };
          return this.currentBundle;
        } else if (prescriptionType === 'Hörhilfenverordnung') {
          await this.createTask();
          const bundle = muster15Resources.createMuster15Bundle();
          this.currentBundle = { bundle };
          return this.currentBundle;
        } else if (prescriptionType === 'Häusliche Krankenpflege') {
          await this.createTask();
          const bundle = await this.createMuster12Bundle();
          this.currentBundle = { bundle };
          return this.currentBundle;
        }

      } catch (error) {
        console.error('Error creating E-Rezept bundle:', error);
        throw error;
      }
    },

    setSelectedPractitioner(practitionerId) {
      this.selectedPractitioner = this.practitioners.find(p => p.uuid === practitionerId) || this.practitioners[0];
    },

    openMusterModal() {
      this.showMusterModal = true;
      this.selectedFormType = null;
    },

    closeMusterModal() {
      this.showMusterModal = false;
      this.selectedFormType = null;
    },

    selectFormType(formType) {
      this.selectedFormType = formType;
    },

    setSelectedPatient(patientId) {
      this.selectedPatient = this.patients.find(p => p.easytiUUID === patientId);
      this.openMusterModal();
    },

    setSelectedOrganization(organizationId) {
      this.selectedOrganization = this.organizations.find(o => o.uuid === organizationId) || this.organizations[0];
    },

    initializeSelections() {
      if (!this.selectedPractitioner && this.practitioners.length > 0) {
        this.selectedPractitioner = this.practitioners[0];
      }
      if (!this.selectedPatient && this.patients.length > 0) {
        this.selectedPatient = this.patients[0];
      }
      if (!this.selectedOrganization && this.organizations.length > 0) {
        this.selectedOrganization = this.organizations[0];
      }
    },

    async fetchData() {
      if (this.dataFetched) return;

      try {
        const [practitioners, patients, organizations, medications] = await Promise.all([
          apiClient.get('/practitioners'),
          apiClient.get('/patients'),
          apiClient.get('/organizations'),
          apiClient.get('/medications'),
        ]);

        this.practitioners = practitioners.data;
        this.patients = patients.data;
        this.organizations = organizations.data;
        this.medications = medications.data;
        this.dataFetched = true;
        this.initializeSelections();
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    },
  },

  getters: {
    getShowMusterModal: (state) => state.showMusterModal,
    getSelectedFormType: (state) => state.selectedFormType,
    getSelectedPractitioner: (state) => state.selectedPractitioner,
    getSelectedPatient: (state) => state.selectedPatient,
    getSelectedOrganization: (state) => state.selectedOrganization,
    getCurrentBundle: (state) => state.currentBundle,
    getCreateTaskResponse: (state) => state.createTaskResponse,
    getMedications: (state) => state.medications,
    getCurrentMedication: (state) => {
      if (state.selectedMedicationPZN) {
        // Finde das Medication-Objekt im Medications-Array, das die PZN enthält
        const medication = state.medications.find(med => med.pzn === state.selectedMedicationPZN);
        return medication || { pzn: state.selectedMedicationPZN };
      } else if (state.medicationFreitext) {
        return {
          text: state.medicationFreitext,
          darreichungsform: state.medicationDarreichungsform
        };
      } else if (state.deviceData) {
        return {
          code: state.deviceData.code,
          display: state.deviceData.display
        };
      }
      return null;
    },
    getCurrentHearingAid: (state) => {
      if (state.muster15Data) {
        return JSON.parse(JSON.stringify(state.muster15Data));
      }
      return null;
    }
  }
});